/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Sort_By_Due_Date_AriaInputs */



/**
* | output |
* | --- |
* | "Sort by due date" |
*
* @param {Explorer_Table_Sort_By_Due_Date_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_sort_by_due_date_aria = /** @type {((inputs?: Explorer_Table_Sort_By_Due_Date_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Sort_By_Due_Date_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Sort by due date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sort by due date")
	return /** @type {LocalizedString} */ ("Sort by due date")
});